<template>
    <el-card class="allot_card">
        <div slot="header" class="clearfix">
            <span style="line-height: 36px;">选视频片广告</span>
            <el-button style="float: right;" type="primary" @click="allotAd">确认分配</el-button>
        </div>
        <div>
            <el-table
            ref="itemSelect"
            v-loading="table_loading"
            element-loading-text="拼命加载中"
            :data="itemData"
            stripe
            border
            fit
            height="500"
            style="width: 100%"
            @selection-change="itemSelectionChange">
                <el-table-column
                    type="selection"
                    width="40">
                </el-table-column>
                <el-table-column
                    prop="num"
                    header-align="center"
                    width="95"
                    label="广告编号">
                </el-table-column>
                <el-table-column
                    prop=""
                    header-align="center"
                    min-width="230"
                    label="链接">
                    <template scope="scope">
                        <el-popover
                          ref="popoverPayStatus1"
                          placement="right-start"
                          trigger="hover">
                          <video controls="controls" style="max-width:200px;margin-top: 6px;">
                            <source :src="scope.row.resource">
                            该浏览器不支持视频播放
                          </video>
                      </el-popover>
                      <a style="color: #337ab7;text-decoration: none;" v-popover:popoverPayStatus1 :href="scope.row.resource" target="_blank">{{scope.row.resource}}</a>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="name"
                    header-align="center"
                    min-width="95"
                    label="广告名称">
                </el-table-column>
                <el-table-column
                    prop="content"
                    header-align="center"
                    min-width="95"
                    label="广告描述">
                </el-table-column>
                <el-table-column
                    prop="createDate"
                    header-align="center"
                    width="120"
                    label="创建时间">
                </el-table-column>
            </el-table>
            <div class="table_pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNo"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageTotal">
                </el-pagination>
            </div>
        </div>
        <pu-allot-pic-video-dialog 
            :allotDialogShow="allotDialogShow"
            :device-list="deviceList"
            :adlist="itemSelect"
            @closeAllotPicVideoDialog="closeAllotPicVideoDialog"
        ></pu-allot-pic-video-dialog>
    </el-card>
</template>

<script>
    import puAllotPicVideoDialog from '@/page/deviceMgr/allotPicVideoDialog'
    import $axios from '../../https/config'
    export default {
      props: ['deviceList'],
      data () {
        return {
          itemData: [],
          itemSelect: [],
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          table_loading: false,
          adResSelectList: [],
          allotDialogShow: false
        }
      },
      created: function () {
        this.pageNo = 1
        this.queryItemDataList(this.pageNo, this.pageSize)
      },
      methods: {
        queryItemDataList (tPageNo, tPageSize, tttt) {
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize,
            type: 'VIDEO'
          }
          this.table_loading = true
          this.itemData = []
          $axios.get('/device/getAdResourcesList', params, 'headers', function (res) {
            _this.table_loading = false
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var item = {
                    num: itemData.id,
                    resource: itemData.url,
                    name: itemData.title,
                    content: itemData.content,
                    createDate: itemData.create_time
                  }
                  resData.push(item)
                }
                _this.itemData = resData
              }
            } else {
            }
          }, function (err) {
            err
          })
        },
        handleSizeChange (val) {
          this.pageSize = val
          this.queryItemDataList(this.pageNo, this.pageSize, '')
        },
        handleCurrentChange (val) {
          this.pageNo = val
          this.queryItemDataList(this.pageNo, this.pageSize, '')
        },
        itemSelectionChange (val) {
          this.itemSelect = val
        },
        allotAd () {
          if (this.itemSelect.length > 0) {
            this.allotDialogShow = true
          } else {
            this.$message({
              type: 'warning',
              duration: 1000 * 5,
              message: '请选择要分配的视频!'
            })
          }
        },
        closeAllotPicVideoDialog (tType) {
          this.allotDialogShow = false
          if (tType === true) {
            this.$emit('boxColose', tType)
          }
        }
      },
      components: {
        'pu-allot-pic-video-dialog': puAllotPicVideoDialog
      }
    }
</script>

<style lang="scss">
    .allot_card {
        margin: 10px;
        position: relative;
        overflow-y: auto;
        height: 85%;

        .el-card__header {
            padding: 10px;
        }
        .el-card__body {
            padding: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/deviceMgr/allotAdVideo.vue